/**
 *
 * Standard formats for revenue figures objects
 *
 * Keys lists come in 2 formats:
 *  * normal: the full path of a property from root
 *  * sub: the sub-path of a property from its parent
 */

const STATUSES = ['guaranteed', 'nonGuaranteed', 'tentative', 'cancelled', 'noShow', 'waitlisted'];

const REVENUE_CATEGORIES = ['accommodation', 'foodAndBeverage', 'ancillary', 'other'];

const ROOM_SUB_KEYS = STATUSES;
const ROOM_KEYS = ROOM_SUB_KEYS.map((key) => `rooms.${key}`);

const REVENUE_SUB_KEYS = REVENUE_CATEGORIES.reduce(
    (accu, category) => [...accu, ...STATUSES.map((status) => `${category}.${status}`)],
    [],
);
const REVENUE_KEYS = REVENUE_SUB_KEYS.map((key) => `revenue.${key}`);

const BUDGET_SUB_KEYS = [
    'rooms',
    ...REVENUE_CATEGORIES.map((category) => `revenue.${category}`),
    'adr',
    'revPar',
    'occupancy',
];
const BUDGET_KEYS = BUDGET_SUB_KEYS.map((key) => `budget.${key}`);

const INVENTORY_SUB_KEYS_OLD = ['total', 'outOfOrder', 'available'];
const INVENTORY_KEYS_OLD = INVENTORY_SUB_KEYS_OLD.map((key) => `inventory.${key}`);

const INVENTORY_SUB_KEYS = ['outOfOrder', 'roomCount', 'availableRoomCount'];
const INVENTORY_KEYS = INVENTORY_SUB_KEYS.map((key) => `inventory.${key}`);

const STATISTIC_SUB_KEYS = ['revenue.accommodation', 'rooms'];
const STATISTIC_KEYS = STATISTIC_SUB_KEYS.map((key) => `statistics.${key}`);

const INVENTORY_BLOCK_ALLOCATIONS_KEYS = [
    'sellLimit',
    'blockedRoomCount',
    'pickedUpRoomCount',
    'revenueEstimate',
    'revenueEstimateOriginal',
];

export {
    STATUSES,
    REVENUE_CATEGORIES,
    ROOM_SUB_KEYS,
    ROOM_KEYS,
    REVENUE_SUB_KEYS,
    REVENUE_KEYS,
    BUDGET_SUB_KEYS,
    BUDGET_KEYS,
    INVENTORY_SUB_KEYS_OLD,
    INVENTORY_SUB_KEYS,
    INVENTORY_KEYS_OLD,
    INVENTORY_KEYS,
    STATISTIC_KEYS,
    INVENTORY_BLOCK_ALLOCATIONS_KEYS,
};
